module.exports = __webpack_public_path__ + "static/media/SWSCRC1-05.1a94ce67.mp3";